"use client";
import { Content } from "@/services/content/types";
import { getColor } from "@/utils/articles";
import classNames from "classnames";
import Link from "next/link";
import SubscribeButton from "./subscribe-button";

type CategoryProps = {
  category: Content.Category;
  inverted?: boolean;
  showFollowToggle?: boolean;
  isLink?: boolean;
  hideColor?: boolean;
  centered?: boolean;
};

const Category = (props: CategoryProps) => {
  const parentCategory = props.category.fields.parentCategory;
  const color = props.category.fields.color || parentCategory?.fields.color;

  return (
    <div
      className={classNames("flex items-center", {
        "justify-center": props.centered,
      })}
    >
      {props.isLink ? (
        <Link href={`/amne/${props.category.fields.slug}`}>
          <CustomCategory
            name={props.category.fields.name}
            color={color}
            inverted={props.inverted}
            hideColor={props.hideColor}
          />
        </Link>
      ) : (
        <CustomCategory
          name={props.category.fields.name}
          color={color}
          inverted={props.inverted}
          hideColor={props.hideColor}
        />
      )}
      {props.showFollowToggle && (
        <SubscribeButton
          item={props.category}
          type="category"
          activeLabel="Följer"
          inactiveLabel="Följ"
          className="ml-5"
        />
      )}
    </div>
  );
};

export default Category;

type CustomCategoryProps = {
  name?: string;
  color?: Content.CategoryColors;
  inverted?: boolean;
  size?: "sm" | "md" | "xs";
  uppercase?: boolean;
  hideColor?: boolean;
};

export const CustomCategory = (props: CustomCategoryProps) => {
  const size = props.size || "xs";
  const uppercase = props.uppercase ?? true;
  const color = getColor(props.color);

  return (
    <div className="flex items-center space-x-1">
      {color && !props.hideColor && (
        <div
          className={classNames(
            "w-[11px] h-[11px] rounded-sm -skew-x-6 mb-[2px] mt-[1px]",
            color,
          )}
        />
      )}

      {props.name && (
        <div
          className={classNames("font-bold", {
            "text-static-white": props.inverted,
            "text-lg": size === "md",
            "text-sm": size != "md",
            uppercase: uppercase,
          })}
        >
          {props.name}
        </div>
      )}
    </div>
  );
};
